import { useFlag } from "@flash-tecnologia/feature-flags";
import { useSelectedCompany } from "@flash-tecnologia/hros-web-utility";
import {
  useCanViewSetup,
  useIsSetupTierEnabled,
  useUpdateFeatureFlagsContext,
} from "@hooks";
import { SetupCard } from "src/components/business-components";
import { VIEW_SETUP_FEATURE_FLAG } from "src/shared/constants";

interface MenuSetupCardProps {
  isCollapsed?: boolean;
}

export const MenuSetupCard = ({ isCollapsed }: MenuSetupCardProps) => {
  const { selectedCompany } = useSelectedCompany();
  const canViewSetup = useCanViewSetup();
  const isSetupEnabled = useFlag({ flagName: VIEW_SETUP_FEATURE_FLAG });
  const { isSetupTierEnabled } = useIsSetupTierEnabled(
    selectedCompany.registrationNumber
  );

  useUpdateFeatureFlagsContext();

  if (!isSetupEnabled || !isSetupTierEnabled || !canViewSetup) return null;

  return <SetupCard isCollapsed={isCollapsed} />;
};
